import { useState } from 'react';

export default () => {
  const [snackBarState, setSnackBarState] = useState({
    opened: false,
    alert: {
      msg: null,
      severity: 'success'
    },
  });

  const inform = (msg, severity) => {
    setSnackBarState({
      alert: {
        severity,
        msg
      },
      opened: true,
    });
  };

  const informSuccess = (msg) => {
    inform(msg, 'success');
  };

  const informError = (msg) => {
    inform(msg, 'error');
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBarState({
      alert: {
        msg: null,
        severity: 'success'
      },
      opened: false,
    });
  };

  const {
    alert,
    opened: snackBarOpened
  } = snackBarState;

  return {
    snackBarOpened,
    alert,
    inform,
    informError,
    informSuccess,
    handleClose,
  };
};
